module.exports = __webpack_public_path__ + "static/media/insect(14).f5dd3f4b.PNG";